import { Link } from "@quintype/components";
import React from "react";
import "./hamburger-menu-list.m.css";
import { addClickTrackingToDataLayer } from "../../helper/datalayer-utils";

function HamburgerMenuList({ menus, isSingleMenu }) {
  return (
    <div styleName="wrapper">
      <div styleName="triangle"></div>
      {menus.map((menu, idx) => (
        <div styleName={`menu ${isSingleMenu ? "single-menu" : ""}`} key={idx} onClick={() => addClickTrackingToDataLayer(menu.url, menu.title, "hamburger-menu")}>
          <Link href={menu.url}>{menu.title}</Link>
        </div>
      ))}
    </div>
  );
}

export default HamburgerMenuList;
